module.exports = __webpack_public_path__ + "img/student-graduation.a375b1a4.svg";